import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { useTenantFeatureFlags } from '@/lib/hooks/use-tenant-feature-flags';
import { ServiceContracts } from '@/pages/service-contracts';
import z from '@/lib/zod';
import { legacyBillingSearch } from '@/routes/-shared/to-invoice-search-schema';
import { optionalSearchString } from '@/lib/zod-search-params';
import { amountSearchParams } from '@/lib/filters/amount-search-params';

export const serviceContractsSearchSchema = commonSearchSchema.extend({
  tab: z.string().nullish(),
  /** Filtro «Origine» della vista Da fatturare (CONTRACT, LABOR, MATERIAL). */
  origin: optionalSearchString(),
  /** Popover «Filtri»: stato del contratto (solo tab Contratti) e cliente. */
  status: optionalSearchString(),
  companyId: optionalSearchString(),
  /** Pannello Filtri degli addebiti: decorrenza e importo (nomi dell'API). */
  dateFrom: optionalSearchString(),
  dateTo: optionalSearchString(),
  ...amountSearchParams,
});

export const Route = createFileRoute(
  '/protected/_layout/service-contracts/_layout'
)({
  validateSearch: serviceContractsSearchSchema,
  beforeLoad: ({ search }) => {
    if (search.tab === 'charges') {
      throw redirect({
        to: '/protected/to-invoice',
        search: legacyBillingSearch(search),
        replace: true,
      });
    }
  },
  component: ServiceContractsLayout,
});

/** Sezione visibile con il permesso E il feature flag del tenant. */
function ServiceContractsLayout() {
  const { canAccessServiceContracts, isLoading } = usePermissions();
  const { isServiceContractsEnabled, isLoading: isLoadingFlags } =
    useTenantFeatureFlags();
  return (
    <RoleGuard
      hasAccess={canAccessServiceContracts && isServiceContractsEnabled}
      isLoading={isLoading || isLoadingFlags}
    >
      <ServiceContracts />
      <Outlet />
    </RoleGuard>
  );
}
